import BaseQuestionModel from '../BaseQuestionModel'
import { IQuestionModelConstructor, QuestionType } from '../types'
import {
  IRadioButtonsQuestionModelState,
  IRadioButtonsResponseValidation,
  RadioButtonsQuestionModelTypes,
  RadioButtonsResponse,
  RadioButtonsSubmitResponse
} from './types'
import { getMediumAssetPath, getSmallAssetPath } from '@aytm/lib/common/assets'

const RadioButtonsQuestionModel: IQuestionModelConstructor<RadioButtonsQuestionModelTypes> = (
  questionSchema,
  action
) => {
  const { model } = BaseQuestionModel<RadioButtonsQuestionModelTypes, IRadioButtonsQuestionModelState>({
    questionType: QuestionType.RADIO_BUTTONS,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse,
    collectPreloadImages
  })
  return model
}

function submitResponse({ response }: IRadioButtonsQuestionModelState) {
  return response
    .filter(answerResponse => answerResponse.selected)
    .map(answerResponse => {
      const submitAnswerResponse: ArrayElementType<RadioButtonsSubmitResponse> = { id: answerResponse.id }
      if (answerResponse.comment) {
        submitAnswerResponse.c = answerResponse.comment
      }
      return submitAnswerResponse
    })
}

function initState(state: IRadioButtonsQuestionModelState): IRadioButtonsQuestionModelState {
  state.response = state.questionSchema.answers.map<ArrayElementType<RadioButtonsResponse>>(answer => {
    return { id: answer.id, selected: false }
  })
  return state
}

function validateResponse({
  response,
  questionSchema
}: IRadioButtonsQuestionModelState): IRadioButtonsResponseValidation {
  if (!questionSchema.answers.filter(a => !a.hidden).length) {
    return {
      valid: true
    }
  } else {
    const selectedAnswerResponses = response.filter(answerResponse => answerResponse.selected)
    if (1 !== selectedAnswerResponses.length) {
      return {
        valid: false
      }
    } else {
      const selectedAnswerResponse = selectedAnswerResponses[0]
      const selectedAnswer = questionSchema.answers.find(answer => answer.id === selectedAnswerResponse.id)
      if (null == selectedAnswer) {
        return { valid: false }
      }
      return {
        valid: 'mandatory' !== selectedAnswer.oe || Boolean(selectedAnswerResponse.comment?.trim())
      }
    }
  }
}

function collectPreloadImages(state: IRadioButtonsQuestionModelState) {
  const questionSchema = state.questionSchema
  return questionSchema.answers.reduce((array: string[], answer) => {
    if (questionSchema.image_grid_columns || (answer?.image && !answer.image.expand))
      array.push(questionSchema.image_grid_columns ? getMediumAssetPath(answer.image) : getSmallAssetPath(answer.image))
    return array
  }, [])
}

export default RadioButtonsQuestionModel
